import { Button, Card, Row, Skeleton } from "antd"
import { isAldeia } from "hooks/useAldeia"
import { cn } from "lib/utils"
import React from "react"
import { Link } from "react-router-dom"
import styles from "./style.module.css"
import { LinkButton } from "./email/AddChannelEmail"

interface ChannelCardProps {
  index: number
  to?: string
  icon: React.ReactNode
  name?: React.ReactNode
  style?: React.CSSProperties
  onClick?: () => void
  disabled?: boolean
  children?: React.ReactNode
  className?: string
  loading?: boolean
}

export default function ChannelCard(props: ChannelCardProps) {
  const ButtonOrLink = props.to ? Link : LinkButton

  return (
    <ButtonOrLink
      key={props.name}
      to={props.to || ""}
      onClick={props.onClick}
      style={{ margin: isAldeia ? undefined : 5, width: isAldeia ? undefined : 177, height: 125, ...props.style }}
      className={cn(
        { [styles.disabled_card]: props.disabled },
        isAldeia && props.disabled && "opacity-30",
        props.loading && "pointer-events-none",
        props.className,
      )}
    >
      <Card
        className={cn(
          styles.channel_card,
          isAldeia
            ? "fc animate-fade-up !animate-duration-200 [&_.ant-card-body]:flex [&_.ant-card-body]:gap-2 [&_.ant-card-body]:flex-col [&_.ant-card-body]:items-center [&_.ant-card-body]:justify-center !bg-base-100 dark:!bg-selected-lighter !border-solid !border !border-separator hover:!border-transparent hover:!shadow-lg transition-all duration-200 dark:duration-75  dark:hover:!bg-selected"
            : "",
        )}
        style={{
          animationDelay: `${30 * props.index}ms`,
        }}
      >
        {props.loading ? (
          <>
            <Skeleton.Avatar active size={44} />
            <Skeleton.Input active style={{ height: 10, width: Math.random() * 60 + 20 }} className="rounded-xl" />
          </>
        ) : (
          <>
            {props.children || (
              <>
                {props.icon}
                <Row
                  justify="center"
                  align="middle"
                  style={{
                    // height: 70,
                    fontSize: 16,
                    fontWeight: 400,
                  }}
                >
                  {props.name}
                </Row>
              </>
            )}
          </>
        )}
      </Card>
    </ButtonOrLink>
  )
}
